import moment from 'moment';

const formatBigNumber = (number, t) => (
  `${t('number', { number: number / (number < 1000000 ? 1 : 1000000) })}${number < 1000000 ? '' : ' M'}`
);

const formatData = (data, isDate = false, fullDate = false, shortenedNumber = false, t) => {
  if (isDate) {
    const momentDate = moment(data);
    if (momentDate.isValid()) {
      return momentDate.format(fullDate ? 'dddd, LL' : 'D/MMM');
    }
  }

  if (typeof data === 'number') {
    return shortenedNumber
      ? formatBigNumber(data, t)
      : t('number', { number: Number(data) });
  }

  return data;
};

export const formatPercent = (percent, t) => `${t('number', { number: (percent * 100).toFixed(0) })}%`;

export default formatData;
